import { createSelector } from "@reduxjs/toolkit";

import type { ICatalogReducerState } from "./types";

const getCatalogReducerState = (state: { catalog: ICatalogReducerState }): ICatalogReducerState => state.catalog;

export const getCatalogBaseCategories = createSelector(getCatalogReducerState, (state) => state.baseCategories);

export const getVariantsSelectionSku = createSelector(getCatalogReducerState, (state) => state.variantsSelectionSku);
